import styled from 'styled-components';
import { Button } from '@snsw-gel/react';

export const NormalWeightButton = styled(Button)`
  font-weight: normal;
`;
